// Where the page filter box (PageFilterBox) filters rows rather than
// highlighting text: the list pages that apply the `?q=` param. Exact paths
// only — a detail page has nothing for `q` to filter. Everywhere else the box
// highlights matches on the page instead of filtering.
export const FILTERABLE_PAGES = [
  "/tasks",
  "/my-tasks",
  "/clients",
  "/contacts",
  "/leads",
  "/billing",
  "/funding",
  "/invoicing",
  "/expenses",
  "/cloud",
  "/settings/audit",
];

export const isFilterablePage = (pathname: string): boolean => FILTERABLE_PAGES.includes(pathname);
